import { render, staticRenderFns } from "./BulletinsWidget.vue?vue&type=template&id=15119cac&scoped=true"
import script from "./BulletinsWidget.vue?vue&type=script&lang=js"
export * from "./BulletinsWidget.vue?vue&type=script&lang=js"
import style0 from "./BulletinsWidget.vue?vue&type=style&index=0&id=15119cac&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15119cac",
  null
  
)

export default component.exports